var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.3981V15.8981H8.25V13.6481H2.25C1.8375 13.6481 1.48438 13.5012 1.19063 13.2075C0.896875 12.9137 0.75 12.5606 0.75 12.1481V3.1481C0.75 2.7356 0.896875 2.38248 1.19063 2.08873C1.48438 1.79498 1.8375 1.6481 2.25 1.6481H15.75C16.1625 1.6481 16.5156 1.79498 16.8094 2.08873C17.1031 2.38248 17.25 2.7356 17.25 3.1481V12.1481C17.25 12.5606 17.1031 12.9137 16.8094 13.2075C16.5156 13.5012 16.1625 13.6481 15.75 13.6481H9.75V15.8981H13.5V17.3981H4.5ZM2.25 12.1481H15.75V3.1481H2.25V12.1481Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38721 10.6856L12.1122 7.6481L7.38721 4.6106V10.6856Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourse);
export default __webpack_public_path__ + "static/media/icon-course.528f2f8ef7f732b1c76a530c99020cb1.svg";
export { ForwardRef as ReactComponent };